import { render, staticRenderFns } from "./ModalTokoRental.vue?vue&type=template&id=92c308d0&"
import script from "./ModalTokoRental.vue?vue&type=script&lang=js&"
export * from "./ModalTokoRental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports